import * as RadixPopover from '@radix-ui/react-popover';
import { Content } from './overrides/content';
import { Trigger } from './overrides/trigger';

export const Popover = {
  ...RadixPopover,
  Trigger,
  Content,
  Arrow: null,
};
